// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3EI30","container":"style_container__17uYX","titlePart":"style_titlePart__1BAhS","propsContainer":"style_propsContainer__1O-Sg"};